/*
 *  I02COSTENERI18n.js
 *
 *  Created by Sébastien Hecart on 2018-10-27 18:45:57 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

export default {
  I02COSTENER_SECTION_0_TITLE: "Coût énergétique par type d'installation",
  I02COSTENER_I04DIMPUISSCHAUD: 'Calculez votre consommation annuelle',
  I02COSTENER_I04DIMPUISCONS: 'Calcul Déperdition Selon bilan de consommation',
  I02COSTENER_in_consoAnnuelle: 'Consommation annuelle'
}
